import { PrinterPlugin } from './types';

export const createWebPrinterPlugin = (_window: Window): PrinterPlugin => {
  return {
    isAvailable: () => true,
    print: async () => _window.print()
  };
};
